import type * as Types from '../types'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export const LineItemFieldsFragmentDoc = gql`
  fragment LineItemFields on LineItem {
    sku
    name
    amount
    location
    totalAmountPerBox
    barcodes
    imageUrl
    tags
    __typename
  }
`
export const CheckingItemFieldsFragmentDoc = gql`
  fragment CheckingItemFields on CheckingItem {
    id
    lineItem {
      ...LineItemFields
    }
    status
    fulfilledAmount
    missingAmount
    exceededAmount
    __typename
  }
  ${LineItemFieldsFragmentDoc}
`
export const DeliveryFieldsFragmentDoc = gql`
  fragment DeliveryFields on Delivery {
    id
    hub {
      id
      alias
    }
    status
    customer {
      name
      orderCount
      address {
        formatted
        street
        number
        complement
        neighborhood
        city
      }
    }
    orderId
    confirmedAt
    rider {
      fullName
      mode
    }
    shopper {
      fullName
    }
    etaMin
    etaMax
    dispatch
    finishedAt
    assortmentType
    deliveryType
    statusHistory {
      statusFrom
      statusTo
      updatedAt
    }
    relatedDeliveries
    products {
      _id
      name
      sku
      amount
      location
      barcodes
      imageUrl
      tags
      salesforceId
      scanningTime
      scannedAmount
      manuallyAmount
      flaggedAmount
      incorrectLocation
      flagged {
        reason
        amount
      }
      manually {
        reason
        amount
      }
      status
    }
    statusItems {
      total
      scanned
      manual
      flagged
      totalPicked
    }
    bags {
      type
      size
      amount
    }
    hasBags
    lastPickUpdate
    locationResume {
      totalOfRefrigerated
      totalOfFrozen
      totalOfRoomTemperature
      totalOfFresh
      location
      shelves {
        fresh
        frozen
        refrigerated
        roomTemperature
      }
    }
    __typename
  }
`
export const DeliveriesPaginatedFieldsFragmentDoc = gql`
  fragment DeliveriesPaginatedFields on DeliveriesPaginated {
    currentPage
    perPage
    totalOfPages
    total
    deliveries {
      ...DeliveryFields
    }
  }
  ${DeliveryFieldsFragmentDoc}
`
export const MovementPickingFieldsFragmentDoc = gql`
  fragment MovementPickingFields on Picking {
    id
    label
    status
    shoppers {
      fullName
    }
    stats {
      fulfilledAmount
      totalAmount
      startedItems
      unavailableItems
      totalItems
    }
    currentShopper {
      code
    }
    __typename
  }
`
export const ReferenceDeliveryFieldsFragmentDoc = gql`
  fragment ReferenceDeliveryFields on ReferenceDelivery {
    id
    referenceType
    deliveryDetails {
      id
      status
      hub {
        id
        alias
      }
      customer {
        name
        orderCount
        address {
          formatted
          street
          number
          complement
          neighborhood
        }
      }
      orderId
      confirmedAt
      rider {
        fullName
      }
      shopper {
        fullName
        code
      }
      etaMax
      etaMin
      assortmentType
      deliveryType
      statusHistory {
        statusFrom
        statusTo
        updatedAt
      }
      relatedDeliveries
    }
    __typename
  }
`
export const MovementDeliveryForPickingFieldsFragmentDoc = gql`
  fragment MovementDeliveryForPickingFields on PickingMovement {
    id
    status
    reference {
      ...ReferenceDeliveryFields
    }
    stats {
      totalAmount
      totalItems
      fulfilledAmount
    }
    __typename
  }
  ${ReferenceDeliveryFieldsFragmentDoc}
`
export const MovementsDeliveriesPaginatedFieldsFragmentDoc = gql`
  fragment MovementsDeliveriesPaginatedFields on MovementsPaginated {
    currentPage
    perPage
    totalOfPages
    total
    movements {
      ...MovementDeliveryForPickingFields
    }
    __typename
  }
  ${MovementDeliveryForPickingFieldsFragmentDoc}
`
export const ReferenceTransferOrderFieldsFragmentDoc = gql`
  fragment ReferenceTransferOrderFields on ReferenceTransferOrder {
    id
    referenceType
    kind
    storageType
    destination {
      id
      name
    }
  }
`
export const MovementForCheckingFieldsFragmentDoc = gql`
  fragment MovementForCheckingFields on Checking {
    id
    status
    movementId
    currentShopper {
      code
    }
    shoppers {
      code
      fullName
    }
    reference {
      ...ReferenceTransferOrderFields
    }
    stats {
      checkedAmount
      checkedItems
      unavailableItems
      totalAmount
      totalItems
      remainingItems
    }
    __typename
  }
  ${ReferenceTransferOrderFieldsFragmentDoc}
`
export const MovementsForCheckingPaginatedFieldsFragmentDoc = gql`
  fragment MovementsForCheckingPaginatedFields on MovementsForCheckingPaginated {
    currentPage
    perPage
    totalOfPages
    total
    checkings {
      ...MovementForCheckingFields
    }
    __typename
  }
  ${MovementForCheckingFieldsFragmentDoc}
`
export const MovementForPickingFieldsFragmentDoc = gql`
  fragment MovementForPickingFields on PickingMovement {
    id
    status
    reference {
      ...ReferenceTransferOrderFields
    }
    checkingStatus
    stats {
      fulfilledAmount
      totalAmount
      startedItems
      unavailableItems
      totalItems
    }
    __typename
  }
  ${ReferenceTransferOrderFieldsFragmentDoc}
`
export const MovementsPaginatedFieldsFragmentDoc = gql`
  fragment MovementsPaginatedFields on MovementsPaginated {
    currentPage
    perPage
    totalOfPages
    total
    movements {
      ...MovementForPickingFields
    }
    __typename
  }
  ${MovementForPickingFieldsFragmentDoc}
`
export const PickingItemFieldsFragmentDoc = gql`
  fragment PickingItemFields on PickingItem {
    id
    lineItem {
      ...LineItemFields
    }
    status
    manualAmount
    scannedAmount
    skippedCount
    unavailableAmount
    isIncorrectLocation
    unavailablePickReasons {
      reason
      amount
    }
    manualPickReasons {
      reason
      amount
    }
    __typename
  }
  ${LineItemFieldsFragmentDoc}
`
export const CheckMovementDeliveryDocument = gql`
  mutation CheckMovementDelivery(
    $movementId: String!
    $checkedAmount: Int!
    $amountActions: [AmountActionInput!]!
  ) {
    checkMovementDelivery(
      input: {
        movementId: $movementId
        checkedAmount: $checkedAmount
        amountActions: $amountActions
      }
    )
  }
`
export type _ICheckMovementDeliveryMutationFn = Apollo.MutationFunction<
  Types._ICheckMovementDeliveryMutation,
  Types._ICheckMovementDeliveryMutationVariables
>

/**
 * __useCheckMovementDeliveryMutation__
 *
 * To run a mutation, you first call `useCheckMovementDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckMovementDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkMovementDeliveryMutation, { data, loading, error }] = useCheckMovementDeliveryMutation({
 *   variables: {
 *      movementId: // value for 'movementId'
 *      checkedAmount: // value for 'checkedAmount'
 *      amountActions: // value for 'amountActions'
 *   },
 * });
 */
export function useCheckMovementDeliveryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types._ICheckMovementDeliveryMutation,
    Types._ICheckMovementDeliveryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types._ICheckMovementDeliveryMutation,
    Types._ICheckMovementDeliveryMutationVariables
  >(CheckMovementDeliveryDocument, options)
}
export type CheckMovementDeliveryMutationHookResult = ReturnType<
  typeof useCheckMovementDeliveryMutation
>
export type CheckMovementDeliveryMutationResult =
  Apollo.MutationResult<Types._ICheckMovementDeliveryMutation>
export type CheckMovementDeliveryMutationOptions = Apollo.BaseMutationOptions<
  Types._ICheckMovementDeliveryMutation,
  Types._ICheckMovementDeliveryMutationVariables
>
export const CloseMovementsDocument = gql`
  mutation CloseMovements(
    $movementIds: [String!]!
    $closingOrigin: ClosingOrigin
  ) {
    finishMovements(
      input: { movementIds: $movementIds, closingOrigin: $closingOrigin }
    ) {
      success
      failed
    }
  }
`
export type _ICloseMovementsMutationFn = Apollo.MutationFunction<
  Types._ICloseMovementsMutation,
  Types._ICloseMovementsMutationVariables
>

/**
 * __useCloseMovementsMutation__
 *
 * To run a mutation, you first call `useCloseMovementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseMovementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeMovementsMutation, { data, loading, error }] = useCloseMovementsMutation({
 *   variables: {
 *      movementIds: // value for 'movementIds'
 *      closingOrigin: // value for 'closingOrigin'
 *   },
 * });
 */
export function useCloseMovementsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types._ICloseMovementsMutation,
    Types._ICloseMovementsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types._ICloseMovementsMutation,
    Types._ICloseMovementsMutationVariables
  >(CloseMovementsDocument, options)
}
export type CloseMovementsMutationHookResult = ReturnType<
  typeof useCloseMovementsMutation
>
export type CloseMovementsMutationResult =
  Apollo.MutationResult<Types._ICloseMovementsMutation>
export type CloseMovementsMutationOptions = Apollo.BaseMutationOptions<
  Types._ICloseMovementsMutation,
  Types._ICloseMovementsMutationVariables
>
export const CompleteMovementCheckingDocument = gql`
  mutation CompleteMovementChecking(
    $checkingId: String!
    $shopperCode: String!
  ) {
    completeMovementChecking(
      input: { checkingId: $checkingId, shopperCode: $shopperCode }
    )
  }
`
export type _ICompleteMovementCheckingMutationFn = Apollo.MutationFunction<
  Types._ICompleteMovementCheckingMutation,
  Types._ICompleteMovementCheckingMutationVariables
>

/**
 * __useCompleteMovementCheckingMutation__
 *
 * To run a mutation, you first call `useCompleteMovementCheckingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteMovementCheckingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeMovementCheckingMutation, { data, loading, error }] = useCompleteMovementCheckingMutation({
 *   variables: {
 *      checkingId: // value for 'checkingId'
 *      shopperCode: // value for 'shopperCode'
 *   },
 * });
 */
export function useCompleteMovementCheckingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types._ICompleteMovementCheckingMutation,
    Types._ICompleteMovementCheckingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types._ICompleteMovementCheckingMutation,
    Types._ICompleteMovementCheckingMutationVariables
  >(CompleteMovementCheckingDocument, options)
}
export type CompleteMovementCheckingMutationHookResult = ReturnType<
  typeof useCompleteMovementCheckingMutation
>
export type CompleteMovementCheckingMutationResult =
  Apollo.MutationResult<Types._ICompleteMovementCheckingMutation>
export type CompleteMovementCheckingMutationOptions =
  Apollo.BaseMutationOptions<
    Types._ICompleteMovementCheckingMutation,
    Types._ICompleteMovementCheckingMutationVariables
  >
export const FinishDeliveryPackingDocument = gql`
  mutation FinishDeliveryPacking(
    $id: String!
    $hubId: String!
    $bags: [BagInput!]
  ) {
    finishDeliveryPacking(data: { deliveryId: $id, hubId: $hubId, bags: $bags })
  }
`
export type _IFinishDeliveryPackingMutationFn = Apollo.MutationFunction<
  Types._IFinishDeliveryPackingMutation,
  Types._IFinishDeliveryPackingMutationVariables
>

/**
 * __useFinishDeliveryPackingMutation__
 *
 * To run a mutation, you first call `useFinishDeliveryPackingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishDeliveryPackingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishDeliveryPackingMutation, { data, loading, error }] = useFinishDeliveryPackingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      hubId: // value for 'hubId'
 *      bags: // value for 'bags'
 *   },
 * });
 */
export function useFinishDeliveryPackingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types._IFinishDeliveryPackingMutation,
    Types._IFinishDeliveryPackingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types._IFinishDeliveryPackingMutation,
    Types._IFinishDeliveryPackingMutationVariables
  >(FinishDeliveryPackingDocument, options)
}
export type FinishDeliveryPackingMutationHookResult = ReturnType<
  typeof useFinishDeliveryPackingMutation
>
export type FinishDeliveryPackingMutationResult =
  Apollo.MutationResult<Types._IFinishDeliveryPackingMutation>
export type FinishDeliveryPackingMutationOptions = Apollo.BaseMutationOptions<
  Types._IFinishDeliveryPackingMutation,
  Types._IFinishDeliveryPackingMutationVariables
>
export const FinishMovementCheckingDocument = gql`
  mutation FinishMovementChecking($checkingId: String!) {
    finishMovementChecking(input: { checkingId: $checkingId })
  }
`
export type _IFinishMovementCheckingMutationFn = Apollo.MutationFunction<
  Types._IFinishMovementCheckingMutation,
  Types._IFinishMovementCheckingMutationVariables
>

/**
 * __useFinishMovementCheckingMutation__
 *
 * To run a mutation, you first call `useFinishMovementCheckingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishMovementCheckingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishMovementCheckingMutation, { data, loading, error }] = useFinishMovementCheckingMutation({
 *   variables: {
 *      checkingId: // value for 'checkingId'
 *   },
 * });
 */
export function useFinishMovementCheckingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types._IFinishMovementCheckingMutation,
    Types._IFinishMovementCheckingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types._IFinishMovementCheckingMutation,
    Types._IFinishMovementCheckingMutationVariables
  >(FinishMovementCheckingDocument, options)
}
export type FinishMovementCheckingMutationHookResult = ReturnType<
  typeof useFinishMovementCheckingMutation
>
export type FinishMovementCheckingMutationResult =
  Apollo.MutationResult<Types._IFinishMovementCheckingMutation>
export type FinishMovementCheckingMutationOptions = Apollo.BaseMutationOptions<
  Types._IFinishMovementCheckingMutation,
  Types._IFinishMovementCheckingMutationVariables
>
export const FinishMovementPackingDocument = gql`
  mutation FinishMovementPacking(
    $movementId: String!
    $shopperCode: String!
    $bags: [PackingBagInput!]
  ) {
    finishMovementPacking(
      input: { movementId: $movementId, shopperCode: $shopperCode, bags: $bags }
    )
  }
`
export type _IFinishMovementPackingMutationFn = Apollo.MutationFunction<
  Types._IFinishMovementPackingMutation,
  Types._IFinishMovementPackingMutationVariables
>

/**
 * __useFinishMovementPackingMutation__
 *
 * To run a mutation, you first call `useFinishMovementPackingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishMovementPackingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishMovementPackingMutation, { data, loading, error }] = useFinishMovementPackingMutation({
 *   variables: {
 *      movementId: // value for 'movementId'
 *      shopperCode: // value for 'shopperCode'
 *      bags: // value for 'bags'
 *   },
 * });
 */
export function useFinishMovementPackingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types._IFinishMovementPackingMutation,
    Types._IFinishMovementPackingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types._IFinishMovementPackingMutation,
    Types._IFinishMovementPackingMutationVariables
  >(FinishMovementPackingDocument, options)
}
export type FinishMovementPackingMutationHookResult = ReturnType<
  typeof useFinishMovementPackingMutation
>
export type FinishMovementPackingMutationResult =
  Apollo.MutationResult<Types._IFinishMovementPackingMutation>
export type FinishMovementPackingMutationOptions = Apollo.BaseMutationOptions<
  Types._IFinishMovementPackingMutation,
  Types._IFinishMovementPackingMutationVariables
>
export const FinishMovementPickingDocument = gql`
  mutation FinishMovementPicking($pickingId: String, $movementId: String) {
    finishMovementPicking(
      input: { pickingId: $pickingId, movementId: $movementId }
    )
  }
`
export type _IFinishMovementPickingMutationFn = Apollo.MutationFunction<
  Types._IFinishMovementPickingMutation,
  Types._IFinishMovementPickingMutationVariables
>

/**
 * __useFinishMovementPickingMutation__
 *
 * To run a mutation, you first call `useFinishMovementPickingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishMovementPickingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishMovementPickingMutation, { data, loading, error }] = useFinishMovementPickingMutation({
 *   variables: {
 *      pickingId: // value for 'pickingId'
 *      movementId: // value for 'movementId'
 *   },
 * });
 */
export function useFinishMovementPickingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types._IFinishMovementPickingMutation,
    Types._IFinishMovementPickingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types._IFinishMovementPickingMutation,
    Types._IFinishMovementPickingMutationVariables
  >(FinishMovementPickingDocument, options)
}
export type FinishMovementPickingMutationHookResult = ReturnType<
  typeof useFinishMovementPickingMutation
>
export type FinishMovementPickingMutationResult =
  Apollo.MutationResult<Types._IFinishMovementPickingMutation>
export type FinishMovementPickingMutationOptions = Apollo.BaseMutationOptions<
  Types._IFinishMovementPickingMutation,
  Types._IFinishMovementPickingMutationVariables
>
export const PauseMovementCheckingDocument = gql`
  mutation PauseMovementChecking($checkingId: String!, $shopperCode: String!) {
    pauseMovementChecking(
      input: { checkingId: $checkingId, shopperCode: $shopperCode }
    )
  }
`
export type _IPauseMovementCheckingMutationFn = Apollo.MutationFunction<
  Types._IPauseMovementCheckingMutation,
  Types._IPauseMovementCheckingMutationVariables
>

/**
 * __usePauseMovementCheckingMutation__
 *
 * To run a mutation, you first call `usePauseMovementCheckingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseMovementCheckingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseMovementCheckingMutation, { data, loading, error }] = usePauseMovementCheckingMutation({
 *   variables: {
 *      checkingId: // value for 'checkingId'
 *      shopperCode: // value for 'shopperCode'
 *   },
 * });
 */
export function usePauseMovementCheckingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types._IPauseMovementCheckingMutation,
    Types._IPauseMovementCheckingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types._IPauseMovementCheckingMutation,
    Types._IPauseMovementCheckingMutationVariables
  >(PauseMovementCheckingDocument, options)
}
export type PauseMovementCheckingMutationHookResult = ReturnType<
  typeof usePauseMovementCheckingMutation
>
export type PauseMovementCheckingMutationResult =
  Apollo.MutationResult<Types._IPauseMovementCheckingMutation>
export type PauseMovementCheckingMutationOptions = Apollo.BaseMutationOptions<
  Types._IPauseMovementCheckingMutation,
  Types._IPauseMovementCheckingMutationVariables
>
export const SendToCheckDocument = gql`
  mutation sendToCheck($pickingIds: [String!]!, $movementId: String!) {
    sendToCheck(input: { pickingIds: $pickingIds, movementId: $movementId }) {
      success
      failed
    }
  }
`
export type _ISendToCheckMutationFn = Apollo.MutationFunction<
  Types._ISendToCheckMutation,
  Types._ISendToCheckMutationVariables
>

/**
 * __useSendToCheckMutation__
 *
 * To run a mutation, you first call `useSendToCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendToCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendToCheckMutation, { data, loading, error }] = useSendToCheckMutation({
 *   variables: {
 *      pickingIds: // value for 'pickingIds'
 *      movementId: // value for 'movementId'
 *   },
 * });
 */
export function useSendToCheckMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types._ISendToCheckMutation,
    Types._ISendToCheckMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types._ISendToCheckMutation,
    Types._ISendToCheckMutationVariables
  >(SendToCheckDocument, options)
}
export type SendToCheckMutationHookResult = ReturnType<
  typeof useSendToCheckMutation
>
export type SendToCheckMutationResult =
  Apollo.MutationResult<Types._ISendToCheckMutation>
export type SendToCheckMutationOptions = Apollo.BaseMutationOptions<
  Types._ISendToCheckMutation,
  Types._ISendToCheckMutationVariables
>
export const SetSignInShopperDocument = gql`
  mutation SetSignInShopper(
    $hubId: String!
    $orderId: String!
    $code: String!
  ) {
    signinShopper(data: { hubId: $hubId, orderId: $orderId, code: $code })
  }
`
export type _ISetSignInShopperMutationFn = Apollo.MutationFunction<
  Types._ISetSignInShopperMutation,
  Types._ISetSignInShopperMutationVariables
>

/**
 * __useSetSignInShopperMutation__
 *
 * To run a mutation, you first call `useSetSignInShopperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSignInShopperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSignInShopperMutation, { data, loading, error }] = useSetSignInShopperMutation({
 *   variables: {
 *      hubId: // value for 'hubId'
 *      orderId: // value for 'orderId'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useSetSignInShopperMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types._ISetSignInShopperMutation,
    Types._ISetSignInShopperMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types._ISetSignInShopperMutation,
    Types._ISetSignInShopperMutationVariables
  >(SetSignInShopperDocument, options)
}
export type SetSignInShopperMutationHookResult = ReturnType<
  typeof useSetSignInShopperMutation
>
export type SetSignInShopperMutationResult =
  Apollo.MutationResult<Types._ISetSignInShopperMutation>
export type SetSignInShopperMutationOptions = Apollo.BaseMutationOptions<
  Types._ISetSignInShopperMutation,
  Types._ISetSignInShopperMutationVariables
>
export const StartMovementCheckingDocument = gql`
  mutation StartMovementChecking($checkingId: String!, $shopperCode: String!) {
    startMovementChecking(
      input: { checkingId: $checkingId, shopperCode: $shopperCode }
    )
  }
`
export type _IStartMovementCheckingMutationFn = Apollo.MutationFunction<
  Types._IStartMovementCheckingMutation,
  Types._IStartMovementCheckingMutationVariables
>

/**
 * __useStartMovementCheckingMutation__
 *
 * To run a mutation, you first call `useStartMovementCheckingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartMovementCheckingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startMovementCheckingMutation, { data, loading, error }] = useStartMovementCheckingMutation({
 *   variables: {
 *      checkingId: // value for 'checkingId'
 *      shopperCode: // value for 'shopperCode'
 *   },
 * });
 */
export function useStartMovementCheckingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types._IStartMovementCheckingMutation,
    Types._IStartMovementCheckingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types._IStartMovementCheckingMutation,
    Types._IStartMovementCheckingMutationVariables
  >(StartMovementCheckingDocument, options)
}
export type StartMovementCheckingMutationHookResult = ReturnType<
  typeof useStartMovementCheckingMutation
>
export type StartMovementCheckingMutationResult =
  Apollo.MutationResult<Types._IStartMovementCheckingMutation>
export type StartMovementCheckingMutationOptions = Apollo.BaseMutationOptions<
  Types._IStartMovementCheckingMutation,
  Types._IStartMovementCheckingMutationVariables
>
export const StartMovementPickingDocument = gql`
  mutation StartMovementPicking(
    $pickingId: String
    $movementId: String
    $shopperCode: String!
  ) {
    startMovementPicking(
      input: {
        pickingId: $pickingId
        movementId: $movementId
        shopperCode: $shopperCode
      }
    )
  }
`
export type _IStartMovementPickingMutationFn = Apollo.MutationFunction<
  Types._IStartMovementPickingMutation,
  Types._IStartMovementPickingMutationVariables
>

/**
 * __useStartMovementPickingMutation__
 *
 * To run a mutation, you first call `useStartMovementPickingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartMovementPickingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startMovementPickingMutation, { data, loading, error }] = useStartMovementPickingMutation({
 *   variables: {
 *      pickingId: // value for 'pickingId'
 *      movementId: // value for 'movementId'
 *      shopperCode: // value for 'shopperCode'
 *   },
 * });
 */
export function useStartMovementPickingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types._IStartMovementPickingMutation,
    Types._IStartMovementPickingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types._IStartMovementPickingMutation,
    Types._IStartMovementPickingMutationVariables
  >(StartMovementPickingDocument, options)
}
export type StartMovementPickingMutationHookResult = ReturnType<
  typeof useStartMovementPickingMutation
>
export type StartMovementPickingMutationResult =
  Apollo.MutationResult<Types._IStartMovementPickingMutation>
export type StartMovementPickingMutationOptions = Apollo.BaseMutationOptions<
  Types._IStartMovementPickingMutation,
  Types._IStartMovementPickingMutationVariables
>
export const UpdateCheckingItemDocument = gql`
  mutation updateCheckingItem(
    $checkingId: String!
    $checkingItemId: String!
    $code: String!
    $amount: Int!
    $kind: CheckingItemKind!
  ) {
    updateCheckingItem(
      input: {
        checkingId: $checkingId
        checkingItemId: $checkingItemId
        code: $code
        amount: $amount
        kind: $kind
      }
    ) {
      ...CheckingItemFields
    }
  }
  ${CheckingItemFieldsFragmentDoc}
`
export type _IUpdateCheckingItemMutationFn = Apollo.MutationFunction<
  Types._IUpdateCheckingItemMutation,
  Types._IUpdateCheckingItemMutationVariables
>

/**
 * __useUpdateCheckingItemMutation__
 *
 * To run a mutation, you first call `useUpdateCheckingItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCheckingItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCheckingItemMutation, { data, loading, error }] = useUpdateCheckingItemMutation({
 *   variables: {
 *      checkingId: // value for 'checkingId'
 *      checkingItemId: // value for 'checkingItemId'
 *      code: // value for 'code'
 *      amount: // value for 'amount'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useUpdateCheckingItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types._IUpdateCheckingItemMutation,
    Types._IUpdateCheckingItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types._IUpdateCheckingItemMutation,
    Types._IUpdateCheckingItemMutationVariables
  >(UpdateCheckingItemDocument, options)
}
export type UpdateCheckingItemMutationHookResult = ReturnType<
  typeof useUpdateCheckingItemMutation
>
export type UpdateCheckingItemMutationResult =
  Apollo.MutationResult<Types._IUpdateCheckingItemMutation>
export type UpdateCheckingItemMutationOptions = Apollo.BaseMutationOptions<
  Types._IUpdateCheckingItemMutation,
  Types._IUpdateCheckingItemMutationVariables
>
export const UpdateDeliveryPickingDocument = gql`
  mutation updateDeliveryPicking(
    $id: String!
    $hubId: String!
    $delivery: UpdateDeliveryPickingInput!
  ) {
    updateDeliveryPicking(id: $id, hubId: $hubId, delivery: $delivery) {
      ...DeliveryFields
    }
  }
  ${DeliveryFieldsFragmentDoc}
`
export type _IUpdateDeliveryPickingMutationFn = Apollo.MutationFunction<
  Types._IUpdateDeliveryPickingMutation,
  Types._IUpdateDeliveryPickingMutationVariables
>

/**
 * __useUpdateDeliveryPickingMutation__
 *
 * To run a mutation, you first call `useUpdateDeliveryPickingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeliveryPickingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeliveryPickingMutation, { data, loading, error }] = useUpdateDeliveryPickingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      hubId: // value for 'hubId'
 *      delivery: // value for 'delivery'
 *   },
 * });
 */
export function useUpdateDeliveryPickingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types._IUpdateDeliveryPickingMutation,
    Types._IUpdateDeliveryPickingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types._IUpdateDeliveryPickingMutation,
    Types._IUpdateDeliveryPickingMutationVariables
  >(UpdateDeliveryPickingDocument, options)
}
export type UpdateDeliveryPickingMutationHookResult = ReturnType<
  typeof useUpdateDeliveryPickingMutation
>
export type UpdateDeliveryPickingMutationResult =
  Apollo.MutationResult<Types._IUpdateDeliveryPickingMutation>
export type UpdateDeliveryPickingMutationOptions = Apollo.BaseMutationOptions<
  Types._IUpdateDeliveryPickingMutation,
  Types._IUpdateDeliveryPickingMutationVariables
>
export const UpdateDeliveryDocument = gql`
  mutation updateDelivery(
    $id: String!
    $hubId: String!
    $delivery: UpdateDeliveryInput!
  ) {
    updateDelivery(id: $id, hubId: $hubId, delivery: $delivery) {
      ...DeliveryFields
    }
  }
  ${DeliveryFieldsFragmentDoc}
`
export type _IUpdateDeliveryMutationFn = Apollo.MutationFunction<
  Types._IUpdateDeliveryMutation,
  Types._IUpdateDeliveryMutationVariables
>

/**
 * __useUpdateDeliveryMutation__
 *
 * To run a mutation, you first call `useUpdateDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeliveryMutation, { data, loading, error }] = useUpdateDeliveryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      hubId: // value for 'hubId'
 *      delivery: // value for 'delivery'
 *   },
 * });
 */
export function useUpdateDeliveryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types._IUpdateDeliveryMutation,
    Types._IUpdateDeliveryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types._IUpdateDeliveryMutation,
    Types._IUpdateDeliveryMutationVariables
  >(UpdateDeliveryDocument, options)
}
export type UpdateDeliveryMutationHookResult = ReturnType<
  typeof useUpdateDeliveryMutation
>
export type UpdateDeliveryMutationResult =
  Apollo.MutationResult<Types._IUpdateDeliveryMutation>
export type UpdateDeliveryMutationOptions = Apollo.BaseMutationOptions<
  Types._IUpdateDeliveryMutation,
  Types._IUpdateDeliveryMutationVariables
>
export const UpdatePickingItemDocument = gql`
  mutation UpdatePickingItem(
    $pickingItemId: String!
    $manualAmount: Int
    $scannedAmount: Int!
    $isUnavailable: Boolean
    $isSkip: Boolean!
    $hubId: String!
    $shopperCode: String!
    $unavailablePickReasons: [UnavailablePickReasonsInput!]
    $manualPickReasons: [ManualPickReasonsInput!]
    $isIncorrectLocation: Boolean
  ) {
    updatePickingItem(
      input: {
        pickingItemId: $pickingItemId
        manualAmount: $manualAmount
        scannedAmount: $scannedAmount
        isUnavailable: $isUnavailable
        isSkip: $isSkip
        hubId: $hubId
        shopperCode: $shopperCode
        unavailablePickReasonsInput: $unavailablePickReasons
        manualPickReasonsInput: $manualPickReasons
        isIncorrectLocation: $isIncorrectLocation
      }
    ) {
      ...PickingItemFields
    }
  }
  ${PickingItemFieldsFragmentDoc}
`
export type _IUpdatePickingItemMutationFn = Apollo.MutationFunction<
  Types._IUpdatePickingItemMutation,
  Types._IUpdatePickingItemMutationVariables
>

/**
 * __useUpdatePickingItemMutation__
 *
 * To run a mutation, you first call `useUpdatePickingItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePickingItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePickingItemMutation, { data, loading, error }] = useUpdatePickingItemMutation({
 *   variables: {
 *      pickingItemId: // value for 'pickingItemId'
 *      manualAmount: // value for 'manualAmount'
 *      scannedAmount: // value for 'scannedAmount'
 *      isUnavailable: // value for 'isUnavailable'
 *      isSkip: // value for 'isSkip'
 *      hubId: // value for 'hubId'
 *      shopperCode: // value for 'shopperCode'
 *      unavailablePickReasons: // value for 'unavailablePickReasons'
 *      manualPickReasons: // value for 'manualPickReasons'
 *      isIncorrectLocation: // value for 'isIncorrectLocation'
 *   },
 * });
 */
export function useUpdatePickingItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types._IUpdatePickingItemMutation,
    Types._IUpdatePickingItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types._IUpdatePickingItemMutation,
    Types._IUpdatePickingItemMutationVariables
  >(UpdatePickingItemDocument, options)
}
export type UpdatePickingItemMutationHookResult = ReturnType<
  typeof useUpdatePickingItemMutation
>
export type UpdatePickingItemMutationResult =
  Apollo.MutationResult<Types._IUpdatePickingItemMutation>
export type UpdatePickingItemMutationOptions = Apollo.BaseMutationOptions<
  Types._IUpdatePickingItemMutation,
  Types._IUpdatePickingItemMutationVariables
>
export const GetAllHubsDocument = gql`
  query GetAllHubs {
    allHubs {
      id
      alias
      isActive
    }
  }
`

/**
 * __useGetAllHubsQuery__
 *
 * To run a query within a React component, call `useGetAllHubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllHubsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllHubsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllHubsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types._IGetAllHubsQuery,
    Types._IGetAllHubsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types._IGetAllHubsQuery,
    Types._IGetAllHubsQueryVariables
  >(GetAllHubsDocument, options)
}
export function useGetAllHubsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types._IGetAllHubsQuery,
    Types._IGetAllHubsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types._IGetAllHubsQuery,
    Types._IGetAllHubsQueryVariables
  >(GetAllHubsDocument, options)
}
export function useGetAllHubsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types._IGetAllHubsQuery,
        Types._IGetAllHubsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    Types._IGetAllHubsQuery,
    Types._IGetAllHubsQueryVariables
  >(GetAllHubsDocument, options)
}
export type GetAllHubsQueryHookResult = ReturnType<typeof useGetAllHubsQuery>
export type GetAllHubsLazyQueryHookResult = ReturnType<
  typeof useGetAllHubsLazyQuery
>
export type GetAllHubsSuspenseQueryHookResult = ReturnType<
  typeof useGetAllHubsSuspenseQuery
>
export type GetAllHubsQueryResult = Apollo.QueryResult<
  Types._IGetAllHubsQuery,
  Types._IGetAllHubsQueryVariables
>
export function refetchGetAllHubsQuery(
  variables?: Types._IGetAllHubsQueryVariables
) {
  return { query: GetAllHubsDocument, variables: variables }
}
export const GetCheckingItemsDocument = gql`
  query GetCheckingItems($checkingId: String!) {
    checkingItems(checkingId: $checkingId) {
      ...CheckingItemFields
    }
  }
  ${CheckingItemFieldsFragmentDoc}
`

/**
 * __useGetCheckingItemsQuery__
 *
 * To run a query within a React component, call `useGetCheckingItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckingItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckingItemsQuery({
 *   variables: {
 *      checkingId: // value for 'checkingId'
 *   },
 * });
 */
export function useGetCheckingItemsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types._IGetCheckingItemsQuery,
    Types._IGetCheckingItemsQueryVariables
  > &
    (
      | { variables: Types._IGetCheckingItemsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types._IGetCheckingItemsQuery,
    Types._IGetCheckingItemsQueryVariables
  >(GetCheckingItemsDocument, options)
}
export function useGetCheckingItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types._IGetCheckingItemsQuery,
    Types._IGetCheckingItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types._IGetCheckingItemsQuery,
    Types._IGetCheckingItemsQueryVariables
  >(GetCheckingItemsDocument, options)
}
export function useGetCheckingItemsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types._IGetCheckingItemsQuery,
        Types._IGetCheckingItemsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    Types._IGetCheckingItemsQuery,
    Types._IGetCheckingItemsQueryVariables
  >(GetCheckingItemsDocument, options)
}
export type GetCheckingItemsQueryHookResult = ReturnType<
  typeof useGetCheckingItemsQuery
>
export type GetCheckingItemsLazyQueryHookResult = ReturnType<
  typeof useGetCheckingItemsLazyQuery
>
export type GetCheckingItemsSuspenseQueryHookResult = ReturnType<
  typeof useGetCheckingItemsSuspenseQuery
>
export type GetCheckingItemsQueryResult = Apollo.QueryResult<
  Types._IGetCheckingItemsQuery,
  Types._IGetCheckingItemsQueryVariables
>
export function refetchGetCheckingItemsQuery(
  variables: Types._IGetCheckingItemsQueryVariables
) {
  return { query: GetCheckingItemsDocument, variables: variables }
}
export const GetCheckingDocument = gql`
  query GetChecking($hubId: String!, $checkingId: String!) {
    movementForChecking(hubId: $hubId, checkingId: $checkingId) {
      ...MovementForCheckingFields
    }
  }
  ${MovementForCheckingFieldsFragmentDoc}
`

/**
 * __useGetCheckingQuery__
 *
 * To run a query within a React component, call `useGetCheckingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckingQuery({
 *   variables: {
 *      hubId: // value for 'hubId'
 *      checkingId: // value for 'checkingId'
 *   },
 * });
 */
export function useGetCheckingQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types._IGetCheckingQuery,
    Types._IGetCheckingQueryVariables
  > &
    (
      | { variables: Types._IGetCheckingQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types._IGetCheckingQuery,
    Types._IGetCheckingQueryVariables
  >(GetCheckingDocument, options)
}
export function useGetCheckingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types._IGetCheckingQuery,
    Types._IGetCheckingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types._IGetCheckingQuery,
    Types._IGetCheckingQueryVariables
  >(GetCheckingDocument, options)
}
export function useGetCheckingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types._IGetCheckingQuery,
        Types._IGetCheckingQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    Types._IGetCheckingQuery,
    Types._IGetCheckingQueryVariables
  >(GetCheckingDocument, options)
}
export type GetCheckingQueryHookResult = ReturnType<typeof useGetCheckingQuery>
export type GetCheckingLazyQueryHookResult = ReturnType<
  typeof useGetCheckingLazyQuery
>
export type GetCheckingSuspenseQueryHookResult = ReturnType<
  typeof useGetCheckingSuspenseQuery
>
export type GetCheckingQueryResult = Apollo.QueryResult<
  Types._IGetCheckingQuery,
  Types._IGetCheckingQueryVariables
>
export function refetchGetCheckingQuery(
  variables: Types._IGetCheckingQueryVariables
) {
  return { query: GetCheckingDocument, variables: variables }
}
export const GetPaginatedDeliveriesDocument = gql`
  query GetPaginatedDeliveries(
    $currentPage: Int!
    $perPage: Int
    $hubId: String!
    $orderId: String
    $status: DeliveryStatus!
    $startDate: DateTime
    $endDate: DateTime
  ) {
    paginatedDeliveries(
      currentPage: $currentPage
      limit: $perPage
      hubId: $hubId
      orderId: $orderId
      status: $status
      startDate: $startDate
      endDate: $endDate
    ) {
      currentPage
      perPage
      totalOfPages
      total
      deliveries {
        ...DeliveryFields
      }
    }
  }
  ${DeliveryFieldsFragmentDoc}
`

/**
 * __useGetPaginatedDeliveriesQuery__
 *
 * To run a query within a React component, call `useGetPaginatedDeliveriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedDeliveriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedDeliveriesQuery({
 *   variables: {
 *      currentPage: // value for 'currentPage'
 *      perPage: // value for 'perPage'
 *      hubId: // value for 'hubId'
 *      orderId: // value for 'orderId'
 *      status: // value for 'status'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetPaginatedDeliveriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types._IGetPaginatedDeliveriesQuery,
    Types._IGetPaginatedDeliveriesQueryVariables
  > &
    (
      | {
          variables: Types._IGetPaginatedDeliveriesQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types._IGetPaginatedDeliveriesQuery,
    Types._IGetPaginatedDeliveriesQueryVariables
  >(GetPaginatedDeliveriesDocument, options)
}
export function useGetPaginatedDeliveriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types._IGetPaginatedDeliveriesQuery,
    Types._IGetPaginatedDeliveriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types._IGetPaginatedDeliveriesQuery,
    Types._IGetPaginatedDeliveriesQueryVariables
  >(GetPaginatedDeliveriesDocument, options)
}
export function useGetPaginatedDeliveriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types._IGetPaginatedDeliveriesQuery,
        Types._IGetPaginatedDeliveriesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    Types._IGetPaginatedDeliveriesQuery,
    Types._IGetPaginatedDeliveriesQueryVariables
  >(GetPaginatedDeliveriesDocument, options)
}
export type GetPaginatedDeliveriesQueryHookResult = ReturnType<
  typeof useGetPaginatedDeliveriesQuery
>
export type GetPaginatedDeliveriesLazyQueryHookResult = ReturnType<
  typeof useGetPaginatedDeliveriesLazyQuery
>
export type GetPaginatedDeliveriesSuspenseQueryHookResult = ReturnType<
  typeof useGetPaginatedDeliveriesSuspenseQuery
>
export type GetPaginatedDeliveriesQueryResult = Apollo.QueryResult<
  Types._IGetPaginatedDeliveriesQuery,
  Types._IGetPaginatedDeliveriesQueryVariables
>
export function refetchGetPaginatedDeliveriesQuery(
  variables: Types._IGetPaginatedDeliveriesQueryVariables
) {
  return { query: GetPaginatedDeliveriesDocument, variables: variables }
}
export const GetDeliveriesDocument = gql`
  query GetDeliveries($hubId: String!) {
    deliveries(hubId: $hubId) {
      ...DeliveryFields
    }
  }
  ${DeliveryFieldsFragmentDoc}
`

/**
 * __useGetDeliveriesQuery__
 *
 * To run a query within a React component, call `useGetDeliveriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveriesQuery({
 *   variables: {
 *      hubId: // value for 'hubId'
 *   },
 * });
 */
export function useGetDeliveriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types._IGetDeliveriesQuery,
    Types._IGetDeliveriesQueryVariables
  > &
    (
      | { variables: Types._IGetDeliveriesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types._IGetDeliveriesQuery,
    Types._IGetDeliveriesQueryVariables
  >(GetDeliveriesDocument, options)
}
export function useGetDeliveriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types._IGetDeliveriesQuery,
    Types._IGetDeliveriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types._IGetDeliveriesQuery,
    Types._IGetDeliveriesQueryVariables
  >(GetDeliveriesDocument, options)
}
export function useGetDeliveriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types._IGetDeliveriesQuery,
        Types._IGetDeliveriesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    Types._IGetDeliveriesQuery,
    Types._IGetDeliveriesQueryVariables
  >(GetDeliveriesDocument, options)
}
export type GetDeliveriesQueryHookResult = ReturnType<
  typeof useGetDeliveriesQuery
>
export type GetDeliveriesLazyQueryHookResult = ReturnType<
  typeof useGetDeliveriesLazyQuery
>
export type GetDeliveriesSuspenseQueryHookResult = ReturnType<
  typeof useGetDeliveriesSuspenseQuery
>
export type GetDeliveriesQueryResult = Apollo.QueryResult<
  Types._IGetDeliveriesQuery,
  Types._IGetDeliveriesQueryVariables
>
export function refetchGetDeliveriesQuery(
  variables: Types._IGetDeliveriesQueryVariables
) {
  return { query: GetDeliveriesDocument, variables: variables }
}
export const GetDeliveryDocument = gql`
  query GetDelivery($hubId: String!, $orderId: String!) {
    delivery(hubId: $hubId, orderId: $orderId) {
      ...DeliveryFields
    }
  }
  ${DeliveryFieldsFragmentDoc}
`

/**
 * __useGetDeliveryQuery__
 *
 * To run a query within a React component, call `useGetDeliveryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveryQuery({
 *   variables: {
 *      hubId: // value for 'hubId'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetDeliveryQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types._IGetDeliveryQuery,
    Types._IGetDeliveryQueryVariables
  > &
    (
      | { variables: Types._IGetDeliveryQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types._IGetDeliveryQuery,
    Types._IGetDeliveryQueryVariables
  >(GetDeliveryDocument, options)
}
export function useGetDeliveryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types._IGetDeliveryQuery,
    Types._IGetDeliveryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types._IGetDeliveryQuery,
    Types._IGetDeliveryQueryVariables
  >(GetDeliveryDocument, options)
}
export function useGetDeliverySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types._IGetDeliveryQuery,
        Types._IGetDeliveryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    Types._IGetDeliveryQuery,
    Types._IGetDeliveryQueryVariables
  >(GetDeliveryDocument, options)
}
export type GetDeliveryQueryHookResult = ReturnType<typeof useGetDeliveryQuery>
export type GetDeliveryLazyQueryHookResult = ReturnType<
  typeof useGetDeliveryLazyQuery
>
export type GetDeliverySuspenseQueryHookResult = ReturnType<
  typeof useGetDeliverySuspenseQuery
>
export type GetDeliveryQueryResult = Apollo.QueryResult<
  Types._IGetDeliveryQuery,
  Types._IGetDeliveryQueryVariables
>
export function refetchGetDeliveryQuery(
  variables: Types._IGetDeliveryQueryVariables
) {
  return { query: GetDeliveryDocument, variables: variables }
}
export const GetHubsDocument = gql`
  query GetHubs {
    hubs {
      id
      alias
      isActive
    }
  }
`

/**
 * __useGetHubsQuery__
 *
 * To run a query within a React component, call `useGetHubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHubsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHubsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHubsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types._IGetHubsQuery,
    Types._IGetHubsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<Types._IGetHubsQuery, Types._IGetHubsQueryVariables>(
    GetHubsDocument,
    options
  )
}
export function useGetHubsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types._IGetHubsQuery,
    Types._IGetHubsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types._IGetHubsQuery,
    Types._IGetHubsQueryVariables
  >(GetHubsDocument, options)
}
export function useGetHubsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types._IGetHubsQuery,
        Types._IGetHubsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    Types._IGetHubsQuery,
    Types._IGetHubsQueryVariables
  >(GetHubsDocument, options)
}
export type GetHubsQueryHookResult = ReturnType<typeof useGetHubsQuery>
export type GetHubsLazyQueryHookResult = ReturnType<typeof useGetHubsLazyQuery>
export type GetHubsSuspenseQueryHookResult = ReturnType<
  typeof useGetHubsSuspenseQuery
>
export type GetHubsQueryResult = Apollo.QueryResult<
  Types._IGetHubsQuery,
  Types._IGetHubsQueryVariables
>
export function refetchGetHubsQuery(variables?: Types._IGetHubsQueryVariables) {
  return { query: GetHubsDocument, variables: variables }
}
export const GetMovementDeliveryForPickingDocument = gql`
  query GetMovementDeliveryForPicking($hubId: String!, $movementId: String!) {
    movementForPicking(hubId: $hubId, movementId: $movementId) {
      ...MovementDeliveryForPickingFields
    }
  }
  ${MovementDeliveryForPickingFieldsFragmentDoc}
`

/**
 * __useGetMovementDeliveryForPickingQuery__
 *
 * To run a query within a React component, call `useGetMovementDeliveryForPickingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovementDeliveryForPickingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovementDeliveryForPickingQuery({
 *   variables: {
 *      hubId: // value for 'hubId'
 *      movementId: // value for 'movementId'
 *   },
 * });
 */
export function useGetMovementDeliveryForPickingQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types._IGetMovementDeliveryForPickingQuery,
    Types._IGetMovementDeliveryForPickingQueryVariables
  > &
    (
      | {
          variables: Types._IGetMovementDeliveryForPickingQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types._IGetMovementDeliveryForPickingQuery,
    Types._IGetMovementDeliveryForPickingQueryVariables
  >(GetMovementDeliveryForPickingDocument, options)
}
export function useGetMovementDeliveryForPickingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types._IGetMovementDeliveryForPickingQuery,
    Types._IGetMovementDeliveryForPickingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types._IGetMovementDeliveryForPickingQuery,
    Types._IGetMovementDeliveryForPickingQueryVariables
  >(GetMovementDeliveryForPickingDocument, options)
}
export function useGetMovementDeliveryForPickingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types._IGetMovementDeliveryForPickingQuery,
        Types._IGetMovementDeliveryForPickingQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    Types._IGetMovementDeliveryForPickingQuery,
    Types._IGetMovementDeliveryForPickingQueryVariables
  >(GetMovementDeliveryForPickingDocument, options)
}
export type GetMovementDeliveryForPickingQueryHookResult = ReturnType<
  typeof useGetMovementDeliveryForPickingQuery
>
export type GetMovementDeliveryForPickingLazyQueryHookResult = ReturnType<
  typeof useGetMovementDeliveryForPickingLazyQuery
>
export type GetMovementDeliveryForPickingSuspenseQueryHookResult = ReturnType<
  typeof useGetMovementDeliveryForPickingSuspenseQuery
>
export type GetMovementDeliveryForPickingQueryResult = Apollo.QueryResult<
  Types._IGetMovementDeliveryForPickingQuery,
  Types._IGetMovementDeliveryForPickingQueryVariables
>
export function refetchGetMovementDeliveryForPickingQuery(
  variables: Types._IGetMovementDeliveryForPickingQueryVariables
) {
  return { query: GetMovementDeliveryForPickingDocument, variables: variables }
}
export const GetMovementForPickingDocument = gql`
  query GetMovementForPicking($hubId: String!, $movementId: String!) {
    movementForPicking(hubId: $hubId, movementId: $movementId) {
      ...MovementForPickingFields
    }
  }
  ${MovementForPickingFieldsFragmentDoc}
`

/**
 * __useGetMovementForPickingQuery__
 *
 * To run a query within a React component, call `useGetMovementForPickingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovementForPickingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovementForPickingQuery({
 *   variables: {
 *      hubId: // value for 'hubId'
 *      movementId: // value for 'movementId'
 *   },
 * });
 */
export function useGetMovementForPickingQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types._IGetMovementForPickingQuery,
    Types._IGetMovementForPickingQueryVariables
  > &
    (
      | {
          variables: Types._IGetMovementForPickingQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types._IGetMovementForPickingQuery,
    Types._IGetMovementForPickingQueryVariables
  >(GetMovementForPickingDocument, options)
}
export function useGetMovementForPickingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types._IGetMovementForPickingQuery,
    Types._IGetMovementForPickingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types._IGetMovementForPickingQuery,
    Types._IGetMovementForPickingQueryVariables
  >(GetMovementForPickingDocument, options)
}
export function useGetMovementForPickingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types._IGetMovementForPickingQuery,
        Types._IGetMovementForPickingQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    Types._IGetMovementForPickingQuery,
    Types._IGetMovementForPickingQueryVariables
  >(GetMovementForPickingDocument, options)
}
export type GetMovementForPickingQueryHookResult = ReturnType<
  typeof useGetMovementForPickingQuery
>
export type GetMovementForPickingLazyQueryHookResult = ReturnType<
  typeof useGetMovementForPickingLazyQuery
>
export type GetMovementForPickingSuspenseQueryHookResult = ReturnType<
  typeof useGetMovementForPickingSuspenseQuery
>
export type GetMovementForPickingQueryResult = Apollo.QueryResult<
  Types._IGetMovementForPickingQuery,
  Types._IGetMovementForPickingQueryVariables
>
export function refetchGetMovementForPickingQuery(
  variables: Types._IGetMovementForPickingQueryVariables
) {
  return { query: GetMovementForPickingDocument, variables: variables }
}
export const GetMovementPickingDocument = gql`
  query GetMovementPicking($id: String!) {
    movementPicking(id: $id) {
      ...MovementPickingFields
    }
  }
  ${MovementPickingFieldsFragmentDoc}
`

/**
 * __useGetMovementPickingQuery__
 *
 * To run a query within a React component, call `useGetMovementPickingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovementPickingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovementPickingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMovementPickingQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types._IGetMovementPickingQuery,
    Types._IGetMovementPickingQueryVariables
  > &
    (
      | { variables: Types._IGetMovementPickingQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types._IGetMovementPickingQuery,
    Types._IGetMovementPickingQueryVariables
  >(GetMovementPickingDocument, options)
}
export function useGetMovementPickingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types._IGetMovementPickingQuery,
    Types._IGetMovementPickingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types._IGetMovementPickingQuery,
    Types._IGetMovementPickingQueryVariables
  >(GetMovementPickingDocument, options)
}
export function useGetMovementPickingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types._IGetMovementPickingQuery,
        Types._IGetMovementPickingQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    Types._IGetMovementPickingQuery,
    Types._IGetMovementPickingQueryVariables
  >(GetMovementPickingDocument, options)
}
export type GetMovementPickingQueryHookResult = ReturnType<
  typeof useGetMovementPickingQuery
>
export type GetMovementPickingLazyQueryHookResult = ReturnType<
  typeof useGetMovementPickingLazyQuery
>
export type GetMovementPickingSuspenseQueryHookResult = ReturnType<
  typeof useGetMovementPickingSuspenseQuery
>
export type GetMovementPickingQueryResult = Apollo.QueryResult<
  Types._IGetMovementPickingQuery,
  Types._IGetMovementPickingQueryVariables
>
export function refetchGetMovementPickingQuery(
  variables: Types._IGetMovementPickingQueryVariables
) {
  return { query: GetMovementPickingDocument, variables: variables }
}
export const GetMovementsPickingsDocument = gql`
  query GetMovementsPickings($movementId: String!) {
    movementPickings(movementId: $movementId) {
      id
      label
      status
      shoppers {
        fullName
      }
      stats {
        fulfilledAmount
        totalAmount
        startedItems
        unavailableItems
        totalItems
      }
      currentShopper {
        code
      }
    }
  }
`

/**
 * __useGetMovementsPickingsQuery__
 *
 * To run a query within a React component, call `useGetMovementsPickingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovementsPickingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovementsPickingsQuery({
 *   variables: {
 *      movementId: // value for 'movementId'
 *   },
 * });
 */
export function useGetMovementsPickingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types._IGetMovementsPickingsQuery,
    Types._IGetMovementsPickingsQueryVariables
  > &
    (
      | {
          variables: Types._IGetMovementsPickingsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types._IGetMovementsPickingsQuery,
    Types._IGetMovementsPickingsQueryVariables
  >(GetMovementsPickingsDocument, options)
}
export function useGetMovementsPickingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types._IGetMovementsPickingsQuery,
    Types._IGetMovementsPickingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types._IGetMovementsPickingsQuery,
    Types._IGetMovementsPickingsQueryVariables
  >(GetMovementsPickingsDocument, options)
}
export function useGetMovementsPickingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types._IGetMovementsPickingsQuery,
        Types._IGetMovementsPickingsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    Types._IGetMovementsPickingsQuery,
    Types._IGetMovementsPickingsQueryVariables
  >(GetMovementsPickingsDocument, options)
}
export type GetMovementsPickingsQueryHookResult = ReturnType<
  typeof useGetMovementsPickingsQuery
>
export type GetMovementsPickingsLazyQueryHookResult = ReturnType<
  typeof useGetMovementsPickingsLazyQuery
>
export type GetMovementsPickingsSuspenseQueryHookResult = ReturnType<
  typeof useGetMovementsPickingsSuspenseQuery
>
export type GetMovementsPickingsQueryResult = Apollo.QueryResult<
  Types._IGetMovementsPickingsQuery,
  Types._IGetMovementsPickingsQueryVariables
>
export function refetchGetMovementsPickingsQuery(
  variables: Types._IGetMovementsPickingsQueryVariables
) {
  return { query: GetMovementsPickingsDocument, variables: variables }
}
export const GetMovementsDeliveriesPaginatedDocument = gql`
  query GetMovementsDeliveriesPaginated(
    $currentPage: Int
    $orderId: String
    $originHubId: String!
    $status: [DeliveryStatus!]
  ) {
    movementsForPickingPaginated(
      referenceType: delivery
      kind: "outbound"
      originHubId: $originHubId
      orderId: $orderId
      currentPage: $currentPage
      deliveryStatuses: $status
    ) {
      ...MovementsDeliveriesPaginatedFields
    }
  }
  ${MovementsDeliveriesPaginatedFieldsFragmentDoc}
`

/**
 * __useGetMovementsDeliveriesPaginatedQuery__
 *
 * To run a query within a React component, call `useGetMovementsDeliveriesPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovementsDeliveriesPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovementsDeliveriesPaginatedQuery({
 *   variables: {
 *      currentPage: // value for 'currentPage'
 *      orderId: // value for 'orderId'
 *      originHubId: // value for 'originHubId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetMovementsDeliveriesPaginatedQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types._IGetMovementsDeliveriesPaginatedQuery,
    Types._IGetMovementsDeliveriesPaginatedQueryVariables
  > &
    (
      | {
          variables: Types._IGetMovementsDeliveriesPaginatedQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types._IGetMovementsDeliveriesPaginatedQuery,
    Types._IGetMovementsDeliveriesPaginatedQueryVariables
  >(GetMovementsDeliveriesPaginatedDocument, options)
}
export function useGetMovementsDeliveriesPaginatedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types._IGetMovementsDeliveriesPaginatedQuery,
    Types._IGetMovementsDeliveriesPaginatedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types._IGetMovementsDeliveriesPaginatedQuery,
    Types._IGetMovementsDeliveriesPaginatedQueryVariables
  >(GetMovementsDeliveriesPaginatedDocument, options)
}
export function useGetMovementsDeliveriesPaginatedSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types._IGetMovementsDeliveriesPaginatedQuery,
        Types._IGetMovementsDeliveriesPaginatedQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    Types._IGetMovementsDeliveriesPaginatedQuery,
    Types._IGetMovementsDeliveriesPaginatedQueryVariables
  >(GetMovementsDeliveriesPaginatedDocument, options)
}
export type GetMovementsDeliveriesPaginatedQueryHookResult = ReturnType<
  typeof useGetMovementsDeliveriesPaginatedQuery
>
export type GetMovementsDeliveriesPaginatedLazyQueryHookResult = ReturnType<
  typeof useGetMovementsDeliveriesPaginatedLazyQuery
>
export type GetMovementsDeliveriesPaginatedSuspenseQueryHookResult = ReturnType<
  typeof useGetMovementsDeliveriesPaginatedSuspenseQuery
>
export type GetMovementsDeliveriesPaginatedQueryResult = Apollo.QueryResult<
  Types._IGetMovementsDeliveriesPaginatedQuery,
  Types._IGetMovementsDeliveriesPaginatedQueryVariables
>
export function refetchGetMovementsDeliveriesPaginatedQuery(
  variables: Types._IGetMovementsDeliveriesPaginatedQueryVariables
) {
  return {
    query: GetMovementsDeliveriesPaginatedDocument,
    variables: variables,
  }
}
export const GetMovementsDeliveriesDocument = gql`
  query GetMovementsDeliveries(
    $hubId: String!
    $deliveryStatuses: [DeliveryStatus!]
  ) {
    movementsForPicking(
      referenceType: delivery
      originHubId: $hubId
      deliveryStatuses: $deliveryStatuses
    ) {
      ...MovementDeliveryForPickingFields
    }
  }
  ${MovementDeliveryForPickingFieldsFragmentDoc}
`

/**
 * __useGetMovementsDeliveriesQuery__
 *
 * To run a query within a React component, call `useGetMovementsDeliveriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovementsDeliveriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovementsDeliveriesQuery({
 *   variables: {
 *      hubId: // value for 'hubId'
 *      deliveryStatuses: // value for 'deliveryStatuses'
 *   },
 * });
 */
export function useGetMovementsDeliveriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types._IGetMovementsDeliveriesQuery,
    Types._IGetMovementsDeliveriesQueryVariables
  > &
    (
      | {
          variables: Types._IGetMovementsDeliveriesQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types._IGetMovementsDeliveriesQuery,
    Types._IGetMovementsDeliveriesQueryVariables
  >(GetMovementsDeliveriesDocument, options)
}
export function useGetMovementsDeliveriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types._IGetMovementsDeliveriesQuery,
    Types._IGetMovementsDeliveriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types._IGetMovementsDeliveriesQuery,
    Types._IGetMovementsDeliveriesQueryVariables
  >(GetMovementsDeliveriesDocument, options)
}
export function useGetMovementsDeliveriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types._IGetMovementsDeliveriesQuery,
        Types._IGetMovementsDeliveriesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    Types._IGetMovementsDeliveriesQuery,
    Types._IGetMovementsDeliveriesQueryVariables
  >(GetMovementsDeliveriesDocument, options)
}
export type GetMovementsDeliveriesQueryHookResult = ReturnType<
  typeof useGetMovementsDeliveriesQuery
>
export type GetMovementsDeliveriesLazyQueryHookResult = ReturnType<
  typeof useGetMovementsDeliveriesLazyQuery
>
export type GetMovementsDeliveriesSuspenseQueryHookResult = ReturnType<
  typeof useGetMovementsDeliveriesSuspenseQuery
>
export type GetMovementsDeliveriesQueryResult = Apollo.QueryResult<
  Types._IGetMovementsDeliveriesQuery,
  Types._IGetMovementsDeliveriesQueryVariables
>
export function refetchGetMovementsDeliveriesQuery(
  variables: Types._IGetMovementsDeliveriesQueryVariables
) {
  return { query: GetMovementsDeliveriesDocument, variables: variables }
}
export const GetMovementsForCheckingDocument = gql`
  query GetMovementsForChecking(
    $originHubId: String!
    $referenceId: String
    $hubDestinationId: String
    $status: [CheckingStatus!]
    $currentPage: Int
  ) {
    movementsForCheckingPaginated(
      originHubId: $originHubId
      referenceId: $referenceId
      hubDestinationId: $hubDestinationId
      status: $status
      currentPage: $currentPage
    ) {
      ...MovementsForCheckingPaginatedFields
    }
  }
  ${MovementsForCheckingPaginatedFieldsFragmentDoc}
`

/**
 * __useGetMovementsForCheckingQuery__
 *
 * To run a query within a React component, call `useGetMovementsForCheckingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovementsForCheckingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovementsForCheckingQuery({
 *   variables: {
 *      originHubId: // value for 'originHubId'
 *      referenceId: // value for 'referenceId'
 *      hubDestinationId: // value for 'hubDestinationId'
 *      status: // value for 'status'
 *      currentPage: // value for 'currentPage'
 *   },
 * });
 */
export function useGetMovementsForCheckingQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types._IGetMovementsForCheckingQuery,
    Types._IGetMovementsForCheckingQueryVariables
  > &
    (
      | {
          variables: Types._IGetMovementsForCheckingQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types._IGetMovementsForCheckingQuery,
    Types._IGetMovementsForCheckingQueryVariables
  >(GetMovementsForCheckingDocument, options)
}
export function useGetMovementsForCheckingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types._IGetMovementsForCheckingQuery,
    Types._IGetMovementsForCheckingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types._IGetMovementsForCheckingQuery,
    Types._IGetMovementsForCheckingQueryVariables
  >(GetMovementsForCheckingDocument, options)
}
export function useGetMovementsForCheckingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types._IGetMovementsForCheckingQuery,
        Types._IGetMovementsForCheckingQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    Types._IGetMovementsForCheckingQuery,
    Types._IGetMovementsForCheckingQueryVariables
  >(GetMovementsForCheckingDocument, options)
}
export type GetMovementsForCheckingQueryHookResult = ReturnType<
  typeof useGetMovementsForCheckingQuery
>
export type GetMovementsForCheckingLazyQueryHookResult = ReturnType<
  typeof useGetMovementsForCheckingLazyQuery
>
export type GetMovementsForCheckingSuspenseQueryHookResult = ReturnType<
  typeof useGetMovementsForCheckingSuspenseQuery
>
export type GetMovementsForCheckingQueryResult = Apollo.QueryResult<
  Types._IGetMovementsForCheckingQuery,
  Types._IGetMovementsForCheckingQueryVariables
>
export function refetchGetMovementsForCheckingQuery(
  variables: Types._IGetMovementsForCheckingQueryVariables
) {
  return { query: GetMovementsForCheckingDocument, variables: variables }
}
export const GetMovementsForPickingDocument = gql`
  query GetMovementsForPicking(
    $currentPage: Int
    $referenceId: String
    $hubDestinationId: String
    $originHubId: String!
  ) {
    movementsForPickingPaginated(
      referenceType: transfer_order
      kind: "outbound"
      originHubId: $originHubId
      hubDestinationId: $hubDestinationId
      referenceId: $referenceId
      currentPage: $currentPage
    ) {
      ...MovementsPaginatedFields
    }
  }
  ${MovementsPaginatedFieldsFragmentDoc}
`

/**
 * __useGetMovementsForPickingQuery__
 *
 * To run a query within a React component, call `useGetMovementsForPickingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovementsForPickingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovementsForPickingQuery({
 *   variables: {
 *      currentPage: // value for 'currentPage'
 *      referenceId: // value for 'referenceId'
 *      hubDestinationId: // value for 'hubDestinationId'
 *      originHubId: // value for 'originHubId'
 *   },
 * });
 */
export function useGetMovementsForPickingQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types._IGetMovementsForPickingQuery,
    Types._IGetMovementsForPickingQueryVariables
  > &
    (
      | {
          variables: Types._IGetMovementsForPickingQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types._IGetMovementsForPickingQuery,
    Types._IGetMovementsForPickingQueryVariables
  >(GetMovementsForPickingDocument, options)
}
export function useGetMovementsForPickingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types._IGetMovementsForPickingQuery,
    Types._IGetMovementsForPickingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types._IGetMovementsForPickingQuery,
    Types._IGetMovementsForPickingQueryVariables
  >(GetMovementsForPickingDocument, options)
}
export function useGetMovementsForPickingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types._IGetMovementsForPickingQuery,
        Types._IGetMovementsForPickingQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    Types._IGetMovementsForPickingQuery,
    Types._IGetMovementsForPickingQueryVariables
  >(GetMovementsForPickingDocument, options)
}
export type GetMovementsForPickingQueryHookResult = ReturnType<
  typeof useGetMovementsForPickingQuery
>
export type GetMovementsForPickingLazyQueryHookResult = ReturnType<
  typeof useGetMovementsForPickingLazyQuery
>
export type GetMovementsForPickingSuspenseQueryHookResult = ReturnType<
  typeof useGetMovementsForPickingSuspenseQuery
>
export type GetMovementsForPickingQueryResult = Apollo.QueryResult<
  Types._IGetMovementsForPickingQuery,
  Types._IGetMovementsForPickingQueryVariables
>
export function refetchGetMovementsForPickingQuery(
  variables: Types._IGetMovementsForPickingQueryVariables
) {
  return { query: GetMovementsForPickingDocument, variables: variables }
}
export const GetPickingItemsDocument = gql`
  query GetPickingItems($pickingId: String, $movementId: String!) {
    pickingItems(input: { pickingId: $pickingId, movementId: $movementId }) {
      ...PickingItemFields
    }
  }
  ${PickingItemFieldsFragmentDoc}
`

/**
 * __useGetPickingItemsQuery__
 *
 * To run a query within a React component, call `useGetPickingItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPickingItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPickingItemsQuery({
 *   variables: {
 *      pickingId: // value for 'pickingId'
 *      movementId: // value for 'movementId'
 *   },
 * });
 */
export function useGetPickingItemsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types._IGetPickingItemsQuery,
    Types._IGetPickingItemsQueryVariables
  > &
    (
      | { variables: Types._IGetPickingItemsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types._IGetPickingItemsQuery,
    Types._IGetPickingItemsQueryVariables
  >(GetPickingItemsDocument, options)
}
export function useGetPickingItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types._IGetPickingItemsQuery,
    Types._IGetPickingItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types._IGetPickingItemsQuery,
    Types._IGetPickingItemsQueryVariables
  >(GetPickingItemsDocument, options)
}
export function useGetPickingItemsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types._IGetPickingItemsQuery,
        Types._IGetPickingItemsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    Types._IGetPickingItemsQuery,
    Types._IGetPickingItemsQueryVariables
  >(GetPickingItemsDocument, options)
}
export type GetPickingItemsQueryHookResult = ReturnType<
  typeof useGetPickingItemsQuery
>
export type GetPickingItemsLazyQueryHookResult = ReturnType<
  typeof useGetPickingItemsLazyQuery
>
export type GetPickingItemsSuspenseQueryHookResult = ReturnType<
  typeof useGetPickingItemsSuspenseQuery
>
export type GetPickingItemsQueryResult = Apollo.QueryResult<
  Types._IGetPickingItemsQuery,
  Types._IGetPickingItemsQueryVariables
>
export function refetchGetPickingItemsQuery(
  variables: Types._IGetPickingItemsQueryVariables
) {
  return { query: GetPickingItemsDocument, variables: variables }
}
export const GetPaginatedDeliveriesByEtaDocument = gql`
  query GetPaginatedDeliveriesByEta(
    $currentPage: Int!
    $perPage: Int
    $hubId: String!
    $status: DeliveryStatus!
    $etaStartDate: DateTime
    $etaEndDate: DateTime
    $deliveryType: DeliveryType!
    $assortmentType: AssortmentType!
  ) {
    paginatedDeliveriesByEta(
      currentPage: $currentPage
      limit: $perPage
      hubId: $hubId
      status: $status
      etaStartDate: $etaStartDate
      etaEndDate: $etaEndDate
      deliveryType: $deliveryType
      assortmentType: $assortmentType
    ) {
      ...DeliveriesPaginatedFields
    }
  }
  ${DeliveriesPaginatedFieldsFragmentDoc}
`

/**
 * __useGetPaginatedDeliveriesByEtaQuery__
 *
 * To run a query within a React component, call `useGetPaginatedDeliveriesByEtaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedDeliveriesByEtaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedDeliveriesByEtaQuery({
 *   variables: {
 *      currentPage: // value for 'currentPage'
 *      perPage: // value for 'perPage'
 *      hubId: // value for 'hubId'
 *      status: // value for 'status'
 *      etaStartDate: // value for 'etaStartDate'
 *      etaEndDate: // value for 'etaEndDate'
 *      deliveryType: // value for 'deliveryType'
 *      assortmentType: // value for 'assortmentType'
 *   },
 * });
 */
export function useGetPaginatedDeliveriesByEtaQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types._IGetPaginatedDeliveriesByEtaQuery,
    Types._IGetPaginatedDeliveriesByEtaQueryVariables
  > &
    (
      | {
          variables: Types._IGetPaginatedDeliveriesByEtaQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types._IGetPaginatedDeliveriesByEtaQuery,
    Types._IGetPaginatedDeliveriesByEtaQueryVariables
  >(GetPaginatedDeliveriesByEtaDocument, options)
}
export function useGetPaginatedDeliveriesByEtaLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types._IGetPaginatedDeliveriesByEtaQuery,
    Types._IGetPaginatedDeliveriesByEtaQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types._IGetPaginatedDeliveriesByEtaQuery,
    Types._IGetPaginatedDeliveriesByEtaQueryVariables
  >(GetPaginatedDeliveriesByEtaDocument, options)
}
export function useGetPaginatedDeliveriesByEtaSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types._IGetPaginatedDeliveriesByEtaQuery,
        Types._IGetPaginatedDeliveriesByEtaQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    Types._IGetPaginatedDeliveriesByEtaQuery,
    Types._IGetPaginatedDeliveriesByEtaQueryVariables
  >(GetPaginatedDeliveriesByEtaDocument, options)
}
export type GetPaginatedDeliveriesByEtaQueryHookResult = ReturnType<
  typeof useGetPaginatedDeliveriesByEtaQuery
>
export type GetPaginatedDeliveriesByEtaLazyQueryHookResult = ReturnType<
  typeof useGetPaginatedDeliveriesByEtaLazyQuery
>
export type GetPaginatedDeliveriesByEtaSuspenseQueryHookResult = ReturnType<
  typeof useGetPaginatedDeliveriesByEtaSuspenseQuery
>
export type GetPaginatedDeliveriesByEtaQueryResult = Apollo.QueryResult<
  Types._IGetPaginatedDeliveriesByEtaQuery,
  Types._IGetPaginatedDeliveriesByEtaQueryVariables
>
export function refetchGetPaginatedDeliveriesByEtaQuery(
  variables: Types._IGetPaginatedDeliveriesByEtaQueryVariables
) {
  return { query: GetPaginatedDeliveriesByEtaDocument, variables: variables }
}
export const LiveCheckingItemsUpdatedDocument = gql`
  subscription LiveCheckingItemsUpdated($checkingId: String!) {
    liveMovementCheckingItemUpdated(id: $checkingId) {
      event
      checkingItem {
        ...CheckingItemFields
      }
    }
  }
  ${CheckingItemFieldsFragmentDoc}
`

/**
 * __useLiveCheckingItemsUpdatedSubscription__
 *
 * To run a query within a React component, call `useLiveCheckingItemsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveCheckingItemsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveCheckingItemsUpdatedSubscription({
 *   variables: {
 *      checkingId: // value for 'checkingId'
 *   },
 * });
 */
export function useLiveCheckingItemsUpdatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    Types._ILiveCheckingItemsUpdatedSubscription,
    Types._ILiveCheckingItemsUpdatedSubscriptionVariables
  > &
    (
      | {
          variables: Types._ILiveCheckingItemsUpdatedSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    Types._ILiveCheckingItemsUpdatedSubscription,
    Types._ILiveCheckingItemsUpdatedSubscriptionVariables
  >(LiveCheckingItemsUpdatedDocument, options)
}
export type LiveCheckingItemsUpdatedSubscriptionHookResult = ReturnType<
  typeof useLiveCheckingItemsUpdatedSubscription
>
export type LiveCheckingItemsUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<Types._ILiveCheckingItemsUpdatedSubscription>
export const LiveCheckingUpdatedDocument = gql`
  subscription LiveCheckingUpdated($checkingId: String!) {
    liveMovementCheckingUpdated(id: $checkingId) {
      ...MovementForCheckingFields
    }
  }
  ${MovementForCheckingFieldsFragmentDoc}
`

/**
 * __useLiveCheckingUpdatedSubscription__
 *
 * To run a query within a React component, call `useLiveCheckingUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveCheckingUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveCheckingUpdatedSubscription({
 *   variables: {
 *      checkingId: // value for 'checkingId'
 *   },
 * });
 */
export function useLiveCheckingUpdatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    Types._ILiveCheckingUpdatedSubscription,
    Types._ILiveCheckingUpdatedSubscriptionVariables
  > &
    (
      | {
          variables: Types._ILiveCheckingUpdatedSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    Types._ILiveCheckingUpdatedSubscription,
    Types._ILiveCheckingUpdatedSubscriptionVariables
  >(LiveCheckingUpdatedDocument, options)
}
export type LiveCheckingUpdatedSubscriptionHookResult = ReturnType<
  typeof useLiveCheckingUpdatedSubscription
>
export type LiveCheckingUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<Types._ILiveCheckingUpdatedSubscription>
export const LiveDeliveriesUpdatedDocument = gql`
  subscription LiveDeliveriesUpdated($hubId: String!) {
    liveDeliveriesUpdated(hubId: $hubId) {
      event
      delivery {
        ...DeliveryFields
      }
    }
  }
  ${DeliveryFieldsFragmentDoc}
`

/**
 * __useLiveDeliveriesUpdatedSubscription__
 *
 * To run a query within a React component, call `useLiveDeliveriesUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveDeliveriesUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveDeliveriesUpdatedSubscription({
 *   variables: {
 *      hubId: // value for 'hubId'
 *   },
 * });
 */
export function useLiveDeliveriesUpdatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    Types._ILiveDeliveriesUpdatedSubscription,
    Types._ILiveDeliveriesUpdatedSubscriptionVariables
  > &
    (
      | {
          variables: Types._ILiveDeliveriesUpdatedSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    Types._ILiveDeliveriesUpdatedSubscription,
    Types._ILiveDeliveriesUpdatedSubscriptionVariables
  >(LiveDeliveriesUpdatedDocument, options)
}
export type LiveDeliveriesUpdatedSubscriptionHookResult = ReturnType<
  typeof useLiveDeliveriesUpdatedSubscription
>
export type LiveDeliveriesUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<Types._ILiveDeliveriesUpdatedSubscription>
export const DeliveryUpdatedDocument = gql`
  subscription DeliveryUpdated($hubId: String!) {
    liveDeliveriesUpdated(hubId: $hubId) {
      event
      delivery {
        ...DeliveryFields
      }
    }
  }
  ${DeliveryFieldsFragmentDoc}
`

/**
 * __useDeliveryUpdatedSubscription__
 *
 * To run a query within a React component, call `useDeliveryUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryUpdatedSubscription({
 *   variables: {
 *      hubId: // value for 'hubId'
 *   },
 * });
 */
export function useDeliveryUpdatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    Types._IDeliveryUpdatedSubscription,
    Types._IDeliveryUpdatedSubscriptionVariables
  > &
    (
      | {
          variables: Types._IDeliveryUpdatedSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    Types._IDeliveryUpdatedSubscription,
    Types._IDeliveryUpdatedSubscriptionVariables
  >(DeliveryUpdatedDocument, options)
}
export type DeliveryUpdatedSubscriptionHookResult = ReturnType<
  typeof useDeliveryUpdatedSubscription
>
export type DeliveryUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<Types._IDeliveryUpdatedSubscription>
export const LiveMovementCheckingItemListUpdatedDocument = gql`
  subscription LiveMovementCheckingItemListUpdated($checkingId: String!) {
    liveMovementCheckingItemListUpdated(checkingId: $checkingId) {
      event
      checkingItem {
        ...CheckingItemFields
      }
    }
  }
  ${CheckingItemFieldsFragmentDoc}
`

/**
 * __useLiveMovementCheckingItemListUpdatedSubscription__
 *
 * To run a query within a React component, call `useLiveMovementCheckingItemListUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveMovementCheckingItemListUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveMovementCheckingItemListUpdatedSubscription({
 *   variables: {
 *      checkingId: // value for 'checkingId'
 *   },
 * });
 */
export function useLiveMovementCheckingItemListUpdatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    Types._ILiveMovementCheckingItemListUpdatedSubscription,
    Types._ILiveMovementCheckingItemListUpdatedSubscriptionVariables
  > &
    (
      | {
          variables: Types._ILiveMovementCheckingItemListUpdatedSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    Types._ILiveMovementCheckingItemListUpdatedSubscription,
    Types._ILiveMovementCheckingItemListUpdatedSubscriptionVariables
  >(LiveMovementCheckingItemListUpdatedDocument, options)
}
export type LiveMovementCheckingItemListUpdatedSubscriptionHookResult =
  ReturnType<typeof useLiveMovementCheckingItemListUpdatedSubscription>
export type LiveMovementCheckingItemListUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<Types._ILiveMovementCheckingItemListUpdatedSubscription>
export const LiveMovementCheckingListUpdatedDocument = gql`
  subscription LiveMovementCheckingListUpdated($originHubId: String!) {
    liveMovementCheckingListUpdated(originHubId: $originHubId) {
      event
      checking {
        ...MovementForCheckingFields
      }
    }
  }
  ${MovementForCheckingFieldsFragmentDoc}
`

/**
 * __useLiveMovementCheckingListUpdatedSubscription__
 *
 * To run a query within a React component, call `useLiveMovementCheckingListUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveMovementCheckingListUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveMovementCheckingListUpdatedSubscription({
 *   variables: {
 *      originHubId: // value for 'originHubId'
 *   },
 * });
 */
export function useLiveMovementCheckingListUpdatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    Types._ILiveMovementCheckingListUpdatedSubscription,
    Types._ILiveMovementCheckingListUpdatedSubscriptionVariables
  > &
    (
      | {
          variables: Types._ILiveMovementCheckingListUpdatedSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    Types._ILiveMovementCheckingListUpdatedSubscription,
    Types._ILiveMovementCheckingListUpdatedSubscriptionVariables
  >(LiveMovementCheckingListUpdatedDocument, options)
}
export type LiveMovementCheckingListUpdatedSubscriptionHookResult = ReturnType<
  typeof useLiveMovementCheckingListUpdatedSubscription
>
export type LiveMovementCheckingListUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<Types._ILiveMovementCheckingListUpdatedSubscription>
export const LiveMovementDeliveryUpdatedDocument = gql`
  subscription LiveMovementDeliveryUpdated($movementId: String!) {
    liveMovementUpdated(id: $movementId) {
      ...MovementDeliveryForPickingFields
    }
  }
  ${MovementDeliveryForPickingFieldsFragmentDoc}
`

/**
 * __useLiveMovementDeliveryUpdatedSubscription__
 *
 * To run a query within a React component, call `useLiveMovementDeliveryUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveMovementDeliveryUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveMovementDeliveryUpdatedSubscription({
 *   variables: {
 *      movementId: // value for 'movementId'
 *   },
 * });
 */
export function useLiveMovementDeliveryUpdatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    Types._ILiveMovementDeliveryUpdatedSubscription,
    Types._ILiveMovementDeliveryUpdatedSubscriptionVariables
  > &
    (
      | {
          variables: Types._ILiveMovementDeliveryUpdatedSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    Types._ILiveMovementDeliveryUpdatedSubscription,
    Types._ILiveMovementDeliveryUpdatedSubscriptionVariables
  >(LiveMovementDeliveryUpdatedDocument, options)
}
export type LiveMovementDeliveryUpdatedSubscriptionHookResult = ReturnType<
  typeof useLiveMovementDeliveryUpdatedSubscription
>
export type LiveMovementDeliveryUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<Types._ILiveMovementDeliveryUpdatedSubscription>
export const LiveMovementUpdatedDocument = gql`
  subscription LiveMovementUpdated($movementId: String!) {
    liveMovementUpdated(id: $movementId) {
      ...MovementForPickingFields
    }
  }
  ${MovementForPickingFieldsFragmentDoc}
`

/**
 * __useLiveMovementUpdatedSubscription__
 *
 * To run a query within a React component, call `useLiveMovementUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveMovementUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveMovementUpdatedSubscription({
 *   variables: {
 *      movementId: // value for 'movementId'
 *   },
 * });
 */
export function useLiveMovementUpdatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    Types._ILiveMovementUpdatedSubscription,
    Types._ILiveMovementUpdatedSubscriptionVariables
  > &
    (
      | {
          variables: Types._ILiveMovementUpdatedSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    Types._ILiveMovementUpdatedSubscription,
    Types._ILiveMovementUpdatedSubscriptionVariables
  >(LiveMovementUpdatedDocument, options)
}
export type LiveMovementUpdatedSubscriptionHookResult = ReturnType<
  typeof useLiveMovementUpdatedSubscription
>
export type LiveMovementUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<Types._ILiveMovementUpdatedSubscription>
export const LiveMovementPickingItemListUpdatedDocument = gql`
  subscription LiveMovementPickingItemListUpdated($pickingId: String!) {
    liveMovementPickingItemListUpdated(pickingId: $pickingId) {
      event
      pickingItem {
        ...PickingItemFields
      }
    }
  }
  ${PickingItemFieldsFragmentDoc}
`

/**
 * __useLiveMovementPickingItemListUpdatedSubscription__
 *
 * To run a query within a React component, call `useLiveMovementPickingItemListUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveMovementPickingItemListUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveMovementPickingItemListUpdatedSubscription({
 *   variables: {
 *      pickingId: // value for 'pickingId'
 *   },
 * });
 */
export function useLiveMovementPickingItemListUpdatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    Types._ILiveMovementPickingItemListUpdatedSubscription,
    Types._ILiveMovementPickingItemListUpdatedSubscriptionVariables
  > &
    (
      | {
          variables: Types._ILiveMovementPickingItemListUpdatedSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    Types._ILiveMovementPickingItemListUpdatedSubscription,
    Types._ILiveMovementPickingItemListUpdatedSubscriptionVariables
  >(LiveMovementPickingItemListUpdatedDocument, options)
}
export type LiveMovementPickingItemListUpdatedSubscriptionHookResult =
  ReturnType<typeof useLiveMovementPickingItemListUpdatedSubscription>
export type LiveMovementPickingItemListUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<Types._ILiveMovementPickingItemListUpdatedSubscription>
export const LiveMovementPickingListUpdatedDocument = gql`
  subscription LiveMovementPickingListUpdated($movementId: String!) {
    liveMovementPickingListUpdated(movementId: $movementId) {
      ...MovementPickingFields
    }
  }
  ${MovementPickingFieldsFragmentDoc}
`

/**
 * __useLiveMovementPickingListUpdatedSubscription__
 *
 * To run a query within a React component, call `useLiveMovementPickingListUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveMovementPickingListUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveMovementPickingListUpdatedSubscription({
 *   variables: {
 *      movementId: // value for 'movementId'
 *   },
 * });
 */
export function useLiveMovementPickingListUpdatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    Types._ILiveMovementPickingListUpdatedSubscription,
    Types._ILiveMovementPickingListUpdatedSubscriptionVariables
  > &
    (
      | {
          variables: Types._ILiveMovementPickingListUpdatedSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    Types._ILiveMovementPickingListUpdatedSubscription,
    Types._ILiveMovementPickingListUpdatedSubscriptionVariables
  >(LiveMovementPickingListUpdatedDocument, options)
}
export type LiveMovementPickingListUpdatedSubscriptionHookResult = ReturnType<
  typeof useLiveMovementPickingListUpdatedSubscription
>
export type LiveMovementPickingListUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<Types._ILiveMovementPickingListUpdatedSubscription>
export const LiveMovementPickingUpdatedDocument = gql`
  subscription LiveMovementPickingUpdated($id: String!) {
    liveMovementPickingUpdated(id: $id) {
      ...MovementPickingFields
    }
  }
  ${MovementPickingFieldsFragmentDoc}
`

/**
 * __useLiveMovementPickingUpdatedSubscription__
 *
 * To run a query within a React component, call `useLiveMovementPickingUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveMovementPickingUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveMovementPickingUpdatedSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLiveMovementPickingUpdatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    Types._ILiveMovementPickingUpdatedSubscription,
    Types._ILiveMovementPickingUpdatedSubscriptionVariables
  > &
    (
      | {
          variables: Types._ILiveMovementPickingUpdatedSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    Types._ILiveMovementPickingUpdatedSubscription,
    Types._ILiveMovementPickingUpdatedSubscriptionVariables
  >(LiveMovementPickingUpdatedDocument, options)
}
export type LiveMovementPickingUpdatedSubscriptionHookResult = ReturnType<
  typeof useLiveMovementPickingUpdatedSubscription
>
export type LiveMovementPickingUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<Types._ILiveMovementPickingUpdatedSubscription>
export const LiveMovementDeliveryListUpdatedDocument = gql`
  subscription LiveMovementDeliveryListUpdated($originHubId: String!) {
    liveMovementListUpdated(originHubId: $originHubId) {
      event
      movement {
        ...MovementDeliveryForPickingFields
      }
    }
  }
  ${MovementDeliveryForPickingFieldsFragmentDoc}
`

/**
 * __useLiveMovementDeliveryListUpdatedSubscription__
 *
 * To run a query within a React component, call `useLiveMovementDeliveryListUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveMovementDeliveryListUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveMovementDeliveryListUpdatedSubscription({
 *   variables: {
 *      originHubId: // value for 'originHubId'
 *   },
 * });
 */
export function useLiveMovementDeliveryListUpdatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    Types._ILiveMovementDeliveryListUpdatedSubscription,
    Types._ILiveMovementDeliveryListUpdatedSubscriptionVariables
  > &
    (
      | {
          variables: Types._ILiveMovementDeliveryListUpdatedSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    Types._ILiveMovementDeliveryListUpdatedSubscription,
    Types._ILiveMovementDeliveryListUpdatedSubscriptionVariables
  >(LiveMovementDeliveryListUpdatedDocument, options)
}
export type LiveMovementDeliveryListUpdatedSubscriptionHookResult = ReturnType<
  typeof useLiveMovementDeliveryListUpdatedSubscription
>
export type LiveMovementDeliveryListUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<Types._ILiveMovementDeliveryListUpdatedSubscription>
export const LiveMovementListUpdatedDocument = gql`
  subscription LiveMovementListUpdated($originHubId: String!) {
    liveMovementListUpdated(originHubId: $originHubId) {
      event
      movement {
        ...MovementForPickingFields
      }
    }
  }
  ${MovementForPickingFieldsFragmentDoc}
`

/**
 * __useLiveMovementListUpdatedSubscription__
 *
 * To run a query within a React component, call `useLiveMovementListUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveMovementListUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveMovementListUpdatedSubscription({
 *   variables: {
 *      originHubId: // value for 'originHubId'
 *   },
 * });
 */
export function useLiveMovementListUpdatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    Types._ILiveMovementListUpdatedSubscription,
    Types._ILiveMovementListUpdatedSubscriptionVariables
  > &
    (
      | {
          variables: Types._ILiveMovementListUpdatedSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    Types._ILiveMovementListUpdatedSubscription,
    Types._ILiveMovementListUpdatedSubscriptionVariables
  >(LiveMovementListUpdatedDocument, options)
}
export type LiveMovementListUpdatedSubscriptionHookResult = ReturnType<
  typeof useLiveMovementListUpdatedSubscription
>
export type LiveMovementListUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<Types._ILiveMovementListUpdatedSubscription>
